import React, {Component} from 'react';
import {Helmet} from 'react-helmet';
import {NavLink, withRouter} from 'react-router-dom';
import {NavToggle} from '..';

import styles from './styles';

// Note: if this uses PureComponent, the active links in the header stop working
class HeaderNavigation extends Component {

  constructor(props) {
    super(props);

    this.state = {
      menuActive: false
    };
  }

  handleNavItemClick = ({ target: { href } }) => {

    // Reload the page if the user clicked on the link for the page they're on
    if (href.endsWith(this.props.location.pathname)) {
      window.location.reload();
    }
  };

  toggleMenu = (menuActive) => this.setState({
    menuActive
  });

  renderBodyElement() {

    // If the mobile menu is active, prevent the document from moving
    if (this.state.menuActive) {
      return <body style={{ overflow: 'hidden' }} />;
    }

    return <body />
  }

  render() {
    const navClasses = [styles.navigation];
    const navLinkProps = {
      className: styles.navItem,
      activeClassName: styles.activeNavItem,
      onClick: this.handleNavItemClick
    };

    if (this.state.menuActive) {
      navClasses.push(styles.navigationActive);
    }

    return (
      <div>
        <Helmet>
          {this.renderBodyElement()}
        </Helmet>
        <NavToggle onClick={this.toggleMenu} />
        <nav className={navClasses.join(' ')}>
          <NavLink exact {...navLinkProps} to="/">{'Image Resizer'}</NavLink>
          <NavLink {...navLinkProps} to="/bulk-resize">{'Bulk Resize'}</NavLink>
          <NavLink {...navLinkProps} to="/compress-images">{'Image Compressor'}</NavLink>
          <div className={styles.parentNavItem}>
            <NavLink {...navLinkProps} to="#">{'PDF Tools'}</NavLink>
            <nav className={styles.subNavigation}>
              <NavLink {...navLinkProps} to="/pdf-compressor">{'PDF Compressor'}</NavLink>
              <NavLink {...navLinkProps} to="/pdf-resize">{'PDF Resizer'}</NavLink>
            </nav>
          </div>
          <div className={styles.parentNavItem}>
            <NavLink {...navLinkProps} to="#">{'Convert Tools'}</NavLink>
            <nav className={styles.subNavigation}>
              <a className={styles.navItem} href="https://www.freeconvert.com/jpg-to-pdf" target="_blank">{'JPG TO PDF'}</a>
              <a className={styles.navItem} href="https://www.freeconvert.com/jpg-to-png" target="_blank">{'JPG TO PNG'}</a>
              <a className={styles.navItem} href="https://www.freeconvert.com/pdf-to-jpg" target="_blank">{'PDF TO JPG'}</a>
              <a className={styles.navItem} href="https://www.freeconvert.com/pdf-to-png" target="_blank">{'PDF TO PNG'}</a>
              <a className={styles.navItem} href="https://www.freeconvert.com/png-to-jpg" target="_blank">{'PNG TO JPG'}</a>
              <a className={styles.navItem} href="https://www.freeconvert.com/png-to-pdf" target="_blank">{'PNG TO PDF'}</a>
            </nav>
          </div>
          <div className={styles.parentNavItem}>
            <NavLink {...navLinkProps} to="/features">{'Features'}</NavLink>
            <nav className={styles.subNavigation}>
              <NavLink {...navLinkProps} to="/features/crop-photo">{'Photo Cropping'}</NavLink>
              <NavLink {...navLinkProps} to="/features/photo-editor">{'Photo Editing'}</NavLink>
              <NavLink {...navLinkProps} to="/features/compress-images">{'Photo Compressing'}</NavLink>
            </nav>
          </div>
        </nav>
      </div>
    );
  }
}

export default withRouter(HeaderNavigation);



// WEBPACK FOOTER //
// ./src/components/HeaderNavigation/index.jsx